import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { isArray, isObject } from 'util';
import { Store } from '@ngrx/store';

import { DropdownItem } from '@gosuite/selects';
import { TourOperatorsActivationState, TourOperatorSetState } from '@gosuite/xena-admin';

import { TranslateService } from '../../../../../shared/i18n/services/translate.service';
import { TourOperatorModel } from '../../models/tour-operator.model';
import { getXenaConfig, State } from '../../../../../shared/state-management/reducers';
import { searchType } from '../../../state-management/reducers';
import { mapDeprecatedTourOperatorSetModel } from '../../../../../shared/services/config/helper/xena-admin-tour-operator-config-helper';

@Injectable()
export class TourOperatorService {
	public customSets$: Observable<DropdownItem[]> = Observable.combineLatest(
		this._store.select(getXenaConfig),
		this._store.select(searchType),
		(config, type) => ({ config: config, type: type })
	).map(res => {
		if (isObject(res.config) && isObject(res.config.tourOperatorSettings)) {
			const sets: Array<DropdownItem> = [];

			if (isObject(res.config.tourOperatorSettings.set1) || (isObject(res.config.tourOperatorSettings.sets) && isArray(res.config.tourOperatorSettings.sets.set1))) {
				const config: TourOperatorSetState = isObject(res.config.tourOperatorSettings.set1)
					? res.config.tourOperatorSettings.set1
					: mapDeprecatedTourOperatorSetModel(res.config.tourOperatorSettings.sets.set1);

				const selectOption: DropdownItem = this._createSetSelectOption(config, 'Set 1', res.type);

				if (isObject(selectOption)) {
					sets.push(selectOption);
				}
			}

			if (isObject(res.config.tourOperatorSettings.set2) || (isObject(res.config.tourOperatorSettings.sets) && isArray(res.config.tourOperatorSettings.sets.set2))) {
				const config: TourOperatorSetState = isObject(res.config.tourOperatorSettings.set2)
					? res.config.tourOperatorSettings.set2
					: mapDeprecatedTourOperatorSetModel(res.config.tourOperatorSettings.sets.set2);

				const selectOption: DropdownItem = this._createSetSelectOption(config, 'Set 2', res.type);

				if (isObject(selectOption)) {
					sets.push(selectOption);
				}
			}

			if (isObject(res.config.tourOperatorSettings.set3) || (isObject(res.config.tourOperatorSettings.sets) && isArray(res.config.tourOperatorSettings.sets.set3))) {
				const config: TourOperatorSetState = isObject(res.config.tourOperatorSettings.set3)
					? res.config.tourOperatorSettings.set3
					: mapDeprecatedTourOperatorSetModel(res.config.tourOperatorSettings.sets.set3);

				const selectOption: DropdownItem = this._createSetSelectOption(config, 'Set 3', res.type);

				if (isObject(selectOption)) {
					sets.push(selectOption);
				}
			}

			return sets;
		}

		return [];
	});

	public constructor(
		private _translateService: TranslateService,
		private _store: Store<State>
	) {}

	public filterTourOperators(filterFlags: Array<string>, operators: Array<TourOperatorModel>, adminConfig: TourOperatorsActivationState): Array<DropdownItem> {
		const filteredOperators: Array<DropdownItem> = [];

		if (isArray(filterFlags) && filterFlags.length > 0) {
			operators.forEach(operator => {
				const hasAllFlags: boolean = filterFlags.every(flag => isArray(operator.flags) && operator.flags.indexOf(flag) !== -1);

				if (
					hasAllFlags && (
						!isObject(adminConfig)
						|| !isObject(adminConfig[operator.rawCode])
						|| adminConfig[operator.rawCode].enabled !== false
					)
				) {
					filteredOperators.push({
						value: operator.code,
						rawValue: operator.rawCode,
						displayName: operator.name,
						displayNameShort: operator.rawCode,
						flags: operator.flags,
						valueLabel: operator.rawCode
					});
				}
			});
		} else {
			operators.forEach(operator => {
				if (
					!isObject(adminConfig)
					|| !isObject(adminConfig[operator.rawCode])
					|| adminConfig[operator.rawCode].enabled !== false
				) {
					filteredOperators.push({
						value: operator.code,
						rawValue: operator.rawCode,
						displayName: operator.name,
						displayNameShort: operator.rawCode,
						flags: operator.flags,
						valueLabel: operator.rawCode
					});
				}
			});
		}

		return filteredOperators;
	}


	private _createSetSelectOption(tourOperatorSet: TourOperatorSetState, setName: string, type: string): DropdownItem {
		const topCodesInsideSetAndActiveTyp: Array<string> = Object.keys(tourOperatorSet).filter(tourOperatorCode => {
			let isActive: boolean;

			switch (type) {
				case 'NF':
					isActive = tourOperatorSet[tourOperatorCode].flight;
					break;

				case 'NH':
					isActive = tourOperatorSet[tourOperatorCode].hotel;
					break;

				case 'PA':
				default:
					isActive = tourOperatorSet[tourOperatorCode].packagedTour;
					break;
			}

			return !!(isActive);
		});

		if (!!(topCodesInsideSetAndActiveTyp.length)) {
			return {
				displayName: setName,
				displayNameShort: setName,
				subtitle: this._translateService.translate('Veranstalter-Set'),
				value: topCodesInsideSetAndActiveTyp.map(tourOperatorCode => 'TOP-' + tourOperatorCode).join(':'),
				rawValue: topCodesInsideSetAndActiveTyp.map(tourOperatorCode => tourOperatorCode).join(':')
			};
		}

		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/xena/core/shared/services/tour-operator/tour-operator.service.ts